import clsx from 'clsx';
import { type ReactNode, useMemo } from 'react';

import * as styles from '../Calendar.sty.js';
import { Month } from '../components/Month.js';
import { useSelectMonth } from '../hooks/useSelectMonth.js';
import {
  NUMBER_OF_MONTH_ROWS,
  NUMBER_OF_MONTHS_PER_ROW,
} from '../types/calendarConfiguration.js';

/**
 * SelectMonthView component
 * Renders a grid of buttons for selecting the month.
 * @internal
 */
export const SelectMonthView = () => {
  const { months } = useSelectMonth();
  const monthsToShow = useMemo(
    (): ReactNode =>
      new Array(NUMBER_OF_MONTH_ROWS).fill(0).map((_, index) => (
        <tr
          key={`${months[index]}-row-${index}`}
          className={clsx([styles.row, styles.monthRow])}
        >
          {months
            .slice(
              index * NUMBER_OF_MONTHS_PER_ROW,
              index * NUMBER_OF_MONTHS_PER_ROW + NUMBER_OF_MONTHS_PER_ROW,
            )
            .map((month) => (
              <Month date={month} key={month.toISOString()} />
            ))}
        </tr>
      )),
    [months],
  );

  return <tbody>{monthsToShow}</tbody>;
};

SelectMonthView['displayName'] = 'SelectMonthView';
